//
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
//component
//redux
//selector
import {
  getAudioUrlFromBailiff,
  resetAll,
} from "store/bailiff/bailiff/dialog/bailiff_dialog.action";

export const TriggerPreview = () => {
  // -------------------------- VAR ----------------------------
  const params = useParams();
  const bailiffId = params?.bailiffId;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  // get audio
  useEffect(() => {
    if (bailiffId) {
      dispatch(getAudioUrlFromBailiff({ id: bailiffId }));
    }
  }, [bailiffId, dispatch]);

  useEffect(() => {
    if (bailiffId) {
      dispatch(resetAll());
    }
  }, [dispatch, bailiffId]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerPreview;
